import { LiveTrack } from "@/components/LiveTrack/LiveTrack";

const LiveTrackPage = () => {
  return <LiveTrack />;
};

export default LiveTrackPage;
